export function sendCallback(element) {
    document.body.appendChild(element);
}
